import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    image:{
        margin: "0 auto",
        height: "30%",
        width: "30%"
    }
}));

export default useStyles;